import { Box, MenuItem, Select, Typography } from "@mui/material";
import { ReactComponent as Calendar } from "../../../assets/child-header-icons/calendar.svg";
import { ReactComponent as Order } from "../../../assets/child-header-icons/orders.svg";
import { ReactComponent as WhiteDownArrow } from "../../../assets/icons/whiteDropdown.svg";
import { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import ChildHeaderCard from "../card-templates/ChildHeaderCard";
import { getIcon } from "../../../utils/iconConfig";
import DatePickerComp from "../react-DatePicker/DatePickerComp";
import { useGlobalContext } from "../../../context/GlobalContext";
import NewSeachBar from "../search/NewSeachBar";
import TabSkeleton from "../TabSkeleton";
import apiClient from "../../../lib/api_client";
import { capitalEachLetter } from "../../../utils/capitalEachLetter";

const OrderHeader = () => {
  const { details, setFilterDate, filterEvent, setFilterEvent } = useGlobalContext();

  const [eventOptions, setEventOptions] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const res = await apiClient.post("/getAllEventType", { pageParam: 1, limit: 1000 });
        setEventOptions(res?.data?.eventTypeData || []);
      } catch (err) {
        console.error("Failed to fetch events:", err);
      }
    };
    fetchEvents();
  }, []);

  const dummyData = [
    {
      icon: getIcon("Diamond", "coloured_back"),
      key: "Diamond Weight : ",
      value: `${details?.diamondWeight} ct`,
    },
    {
      icon: getIcon("GoldBar", "coloured_back"),
      key: "Gold Weight : ",
      value: `${details?.goldWeight} g`,
    },
    {
      icon: getIcon("Ring", "back"),
      key: "Design Count : ",
      value: `${details?.designCount}`,
    },
  ];

  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(null);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoader(false), 1000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  const onChange = (dates) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  const handleClear = () => {
    setStartDate(new Date());
    setEndDate(null);
  };

  const handleApply = () => {
    setFilterDate({
      startDate,
      endDate,
    });
  };

  return (
    <Box
      sx={{
        width: "100%",
        background: "#000000",
        height: "12vh",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "1vw",
        gap: ".8vw",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: ".8vw",
          marginLeft: "1.6vw",
          flex: 1,
          minWidth: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: ".25vw" }}>
          <Order />
          <Typography
            fontFamily={"Poppins"}
            fontSize={"1vw"}
            fontWeight={"500"}
          >
            Orders
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: ".8vw",
            flexShrink: 0,
          }}
        >
          {loader ? (
            <TabSkeleton height={"2.5vw"} width={"16vw"} count={3} />
          ) : (
            dummyData?.map((data, index) => (
              <ChildHeaderCard
                key={index}
                icon={data.icon}
                title={data.key}
                value={data.value}
                width={"16vw"}
              />
            ))
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: "1vw",
          marginRight: "1.6vw",
        }}
      >
        <NewSeachBar />
        <Select
          displayEmpty
          value={filterEvent}
          onChange={(e) => setFilterEvent(e.target.value)}
          IconComponent={WhiteDownArrow}
          renderValue={(selected) => {
            if (!selected) {
              return <span style={{ color: "#EDEDEB" }}>All Events</span>;
            }
            const ev = eventOptions.find((e) => e._id === selected);
            return ev ? capitalEachLetter(ev.eventTypeName) : "";
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: ".025vw solid #595959",
                borderRadius: ".75vw",
                backgroundColor: "#FFFFFF",
                height: "fit-content",
                minWidth: "10vw",
                fontSize: ".8vw",
                fontFamily: "Poppins",
                lineHeight: "100%",
                color: "#262626",
                padding: ".25vw",
                maxHeight: "9.3vw",
                overflowY: "scroll",
                "& .MuiList-root": { paddingTop: 0, paddingBottom: 0 },
                "& .MuiMenuItem-root": {
                  fontFamily: "Karla",
                  fontWeight: 500,
                  fontSize: ".9vw",
                  justifyContent: "start",
                  "&.Mui-selected": {
                    backgroundColor: "#262626",
                    color: "white",
                    borderRadius: ".25vw",
                  },
                  "&.Mui-selected:hover": {
                    backgroundColor: "#262626",
                    color: "white",
                    borderRadius: ".25vw",
                  },
                  "&:hover": {
                    backgroundColor: "#262626",
                    color: "white",
                    borderRadius: ".25vw",
                  },
                },
              },
            },
          }}
          sx={{
            height: "2.3vw",
            minWidth: "10vw",
            fontFamily: "Poppins",
            fontWeight: 500,
            fontSize: ".8vw",
            color: "#fff",
            "& .MuiOutlinedInput-notchedOutline": {
              border: ".025vw solid #595959",
              borderRadius: ".25vw",
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              borderColor: "#595959",
            },
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: ".025vw solid #595959",
            },
          }}
        >
          <MenuItem value="" sx={{ backgroundColor: "#FFFFFF", color: "#262626" }}>
            All Events
          </MenuItem>
          {eventOptions.map((ev) => (
            <MenuItem
              key={ev._id}
              value={ev._id}
              sx={{ backgroundColor: "#FFFFFF", color: "#262626" }}
            >
              {capitalEachLetter(ev.eventTypeName)}
            </MenuItem>
          ))}
        </Select>
        <Calendar
          cursor="pointer"
          position="relative"
          onClick={() => setIsCalendarOpen(true)}
        />
        <DatePickerComp
          startDate={startDate}
          onChange={onChange}
          endDate={endDate}
          handleClear={handleClear}
          open={isCalendarOpen}
          handleClose={() => setIsCalendarOpen(false)}
          handleApply={handleApply}
        />
      </Box>
    </Box>
  );
};

export default OrderHeader;
